module.exports = __webpack_public_path__ + "img/prize-03.c154f598.png";